let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("ayZeo")).then(() => parcelRequire('63OXZ'));